// Ahmedabad Banner Images
import BannerImage from "../images/banner-image.jpg";
import BannerImageSecond from "../images/banner-image-second.jpg";
import BannerImageThird from "../images/banner-image-third.jpg";

// Ahmedabad Bike Showcase Slider 
import Case1 from "../images/unisex-bike-slider.jpg";
import Case2 from "../images/stay-secure-slider.jpg";
import Case3 from "../images/easy-adjustable-seat.jpg";
import Case4 from "../images/frame-mounted-basket.jpg";
import Case5 from "../images/bottle-cage.jpg";

import Subscript from "../images/subscription-date.svg";
import Locationhome from "../images/location-home.svg";
import MyBykRide from "../images/riding-bike.svg";

// Banner Image For Mysuru 
import BannerImageMySuru from "../images/banner-image-mysuru.jpg"

// Banner Image For jhansi
import BannerImageJhansi from "../images/banner-image-jhansi.jpg"

// Ahmedabad Bike Showcase Slider 
import JhansiE1 from "../images/e1-bike.jpg";
import PowerPedal from "../images/power-pedal-e1.jpg";
import ChargeAtHome from "../images/charge-at-home-e1.jpg";
import StaySecure from "../images/stay-secure-e1.jpg";
import AdjustableSeat from "../images/easy-adjustable-e1.jpg";

import MysuruE1 from "../images/e1-bike-mysuru.jpg";
import ChargeAtHomeMysuru from "../images/charge-at-home-mysuru.jpg";

import InstagramThumbnail from "../images/instagram-thumbnail.jpg"

const cityContent = [
    {
        "ahmedabad": {
            "city_name": "ahmedabad",
            "banner_heading_local": "કેમ છો અમદાવાદ?",
            "banner_sub_heading": "Welcome to hassle free cycling",
            "banner_price_description": "Your all-inclusive bike subscription with free repairs and maintenance.",
            // For Banner Slider
            "banner_slider": [
                BannerImage,
                BannerImageSecond,
                BannerImageThird
            ],
            // For Bike Showcase Slider
            "bike_showcase": [
                {
                    title: "Unisex Bike",
                    description:
                        "Strong & lightweight frame",
                    image: Case1,
                },
                {
                    title: "Stay Secure",
                    description: "Smart lock with IoT",
                    image: Case2,
                },
                {
                    title: "Easy Adjustable Seat",
                    description: "Simply pull, adjust & push ",
                    image: Case3,
                },
                {
                    title: "Frame Mounted Basket",
                    description:
                        "Carry upto 7 kgs payload",
                    image: Case4,
                },
                {
                    title: "Bottle Cage",
                    description: "Stay hydrated, ride strong",
                    image: Case5,
                },
            ],

            // For How To Use MYBYK
            "how_to_use": [
                {
                    title: "Subscribe",
                    description: "Choose from our easily affordable plans - Daily, Weekly, Monthly or Pay As You Go.",
                    image: Subscript,
                    alt: "subscription"
                },
                {
                    isArrow: true
                },
                {
                    title: "Get your bike",
                    description: "Pick up your bike from the nearest MYBYK Hub or have it delivered right at your doorstep.",
                    image: Locationhome,
                    alt: "location-icon"
                },
                {
                    isArrow: true
                },
                {
                    title: "Ride it like you own it!",
                    description: "Enjoy a worry-free ride! Replace malfunctioning bikes at any MYBYK Hub or right at your doorstep.",
                    image: MyBykRide,
                    alt: "riding-my-byk"
                }
            ],

            // For Swap Your Bike Section 
            "swap_header_title": "Swap your Bike <span>at any BRTS Station</span>",
            "swap_description": "Long commute? Use MYBYK to connect your first and last mile with Ahmedabad BRTS. Drop & Pick MYBYK at <b>75+ BRTS stations.</b>",
            "swap_sub_description": "",
            "map_input_placeholder": "Search a MYBYK hub near you",
            "swap_main_video": "https://youtu.be/7BlEKWCzFSg?si=I47YlB2owVDNY7z6",
            // Hear out stories  
            "hear_out_header_title": "Hear out stories <span>of MYBYKERS</span>",

            // Here out stories video 
            "hear_out_video": [
                {
                    video: "https://www.youtube.com/embed/a6S5JB_F3oA",
                },
                {
                    video: "https://www.youtube.com/embed/8rjprkY7QkQ",
                },
                {
                    video: "https://www.youtube.com/embed/x6PTsyRh_Ek?si=U4LLzKVkut0TOvIG",
                },
            ],

            // FAQ Section Question Answers 

            "faq_question_answers": [
                {
                    question: "How do I subscribe to MYBYK?",
                    answer:
                        "Subscribing is super simple! Visit our website or app, select a plan, make the payment, and either pick up your bike from a nearby hub or choose home delivery (available in select areas).",
                },
                {
                    question: "Where can I pick up and drop off MYBYK bicycles?",
                    answer:
                        "You can pick up a bike from any MYBYK hub in Ahmedabad and drop it off at any other hub for your convenience. Plus, you can swap bicycles at any BRTS station (75+ MYBYK hubs) to enjoy seamless first and last-mile connectivity.",
                },
                {
                    question: "What type of bicycles does MYBYK provide?",
                    answer:
                        "MYBYK offers high-quality pedal cycles built for daily commuting and city exploration. They are lightweight, durable, and perfect for rides of any length.",
                },

                {
                    question: "Are MYBYK bicycles available near Metro and BRTS stations?",
                    answer:
                        "Absolutely! MYBYK hubs are conveniently located near major Metro and BRTS stations, making your travel smooth and efficient.",
                },
                {
                    question: "What happens if the bicycle gets damaged?",
                    answer:
                        "No worries! If the bicycle is damaged, visit your nearest MYBYK hub and swap it for a replacement with your existing subscription at no extra cost.",
                },
                {
                    question: "Can I cancel my subscription anytime?",
                    answer:
                        "Yes, you can! Just return the bike to your nearest MYBYK hub, and your subscription will be canceled with no hassle.",
                },
            ]
        },
        "jhansi": {
            "city_name": "jhansi",
            "banner_heading_local": "नमस्ते झांसी",
            "banner_sub_heading": "Cycling made easy and affordable",
            "banner_price_description": "Subscribe and ride with zero worries.",
            "banner_slider": [
                BannerImageJhansi
            ],

            "bike_showcase": [
                {
                    title: "Unisex Bike",
                    description:
                        "Strong & lightweight frame",
                    image: JhansiE1,
                },
                {
                    title: "PowerPedal",
                    description: "Pedal + Electric boost",
                    image: PowerPedal,
                },
                {
                    title: "Charge at home",
                    description: "50+ km range in a single charge!*",
                    image: ChargeAtHome,
                },
                {
                    title: "Stay Secure",
                    description:
                        "Smart lock with IoT",
                    image: StaySecure,
                },
                {
                    title: "Easy Adjustable Seat",
                    description: "Simply pull, adjust & push ",
                    image: AdjustableSeat,
                },
            ],

            "how_to_use": [
                {
                    title: "Subscribe",
                    description: "Choose from our easily affordable plans - Daily, Weekly, Monthly or Pay As You Go.",
                    image: Subscript,
                    alt: "subscription"
                },
                {
                    isArrow: true
                },
                {
                    title: "Get your bike",
                    description: "Pick up your bike from the nearest MYBYK Hub or have it delivered right at your doorstep.",
                    image: Locationhome,
                    alt: "location-icon"
                },
                {
                    isArrow: true
                },
                {
                    title: "Ride it like you own it!",
                    description: "Enjoy a worry-free ride! Replace malfunctioning bikes at any MYBYK Hub or right at your doorstep.",
                    image: MyBykRide,
                    alt: "riding-my-byk"
                }
            ],

            "swap_header_title": "Swap your bike at <span>any MYBYK Hub</span>",
            "swap_description": "With MYBYK, you can use the swap feature, drop your E1 bicycles at any MYBYK hub and pick another one from any other MYBYK hub across the city",
            "swap_sub_description": "Enjoy the flexibility to drop & pick E1 cycles at <b>18+ MYBYK Hubs</b> across Jhansi.",
            "swap_main_video": "https://youtu.be/7BlEKWCzFSg?si=I47YlB2owVDNY7z6",
            "map_input_placeholder": "Search a MYBYK hub near you",

            // Hear out stories  
            "hear_out_header_title": "Hear out stories <span>of MYBYKERS</span>",

            // Here out stories video 
            "hear_out_video": [
                {
                    video: "https://youtube.com/embed/wPr0Wb-y-j4",
                },
                {
                    video: "https://youtube.com/embed/DBgmfG4XoRc",
                },
                {
                    video: "https://youtube.com/shorts/rlnY6lwwD1c?si=-XNmpBvyx33_tiv6",
                },
            ],

            // FAQ Section Question Answers 

            "faq_question_answers": [
                {
                    question: "How do I subscribe to MYBYK Electric?",
                    answer:
                        "Subscribing is simple! Visit our website or app, select a plan, make the payment, and either pick up your bike from a nearby MYBYK hub or choose home delivery (available in select areas).",
                },
                {
                    question: "Where can I pick up and drop off the bike?",
                    answer:
                        "You can pick up a bike from any MYBYK hub in Jhansi and drop it off at any other hub. With 19+ MYBYK hubs across the city, we ensure you're never far from a hub.",
                },
                {
                    question: "What kind of bicycles does MYBYK offer?",
                    answer:
                        "MYBYK offers high-quality electric bicycles designed for daily commuting and city exploration. They are lightweight, durable, and equipped with a pedal-assist feature, perfect for smooth rides without breaking a sweat.",
                },
                {
                    question: "Are MYBYK hubs located conveniently?",
                    answer:
                        "Absolutely! MYBYK hubs are strategically located across Jhansi, ensuring you have easy access to our bikes near key landmarks and transport points.",
                },
                {
                    question: "What if the bicycle malfunctions??",
                    answer:
                        "No problem! If the bicycle malfunctions, simply visit your nearest MYBYK hub and swap it for a replacement with your current subscription, at no additional cost.",
                },
                {
                    question: "Can I cancel my subscription anytime?",
                    answer:
                        "Yes, you can! Just return the bike to your nearest MYBYK hub, and your subscription will be canceled—hassle-free.",
                },
            ]
        },
        "kochi": {
            "city_name": "kochi",
            "banner_heading_local": "നമസ്കാരം കൊച്ചി",
            "banner_sub_heading": "Smart cycling starts here",
            "banner_price_description": "Kochi, ride smarter with subscription.",
            "banner_slider": [
                BannerImage,
                BannerImageSecond,
                BannerImageThird
            ],
            "bike_showcase": [
                {
                    title: "Unisex Bike",
                    description:
                        "Strong & lightweight frame",
                    image: Case1,
                },
                {
                    title: "Stay Secure",
                    description: "Smart lock with IoT",
                    image: Case2,
                },
                {
                    title: "Easy Adjustable Seat",
                    description: "Simply pull, adjust & push ",
                    image: Case3,
                },
                {
                    title: "Frame Mounted Basket",
                    description:
                        "Carry upto 7 kgs payload",
                    image: Case4,
                },
                {
                    title: "Bottle Cage",
                    description: "Stay hydrated, ride strong",
                    image: Case5,
                },
            ],
            "how_to_use": [
                {
                    title: "Subscribe",
                    description: "Choose from our easily affordable plans - Daily, Weekly, Monthly or Pay As You Go.",
                    image: Subscript,
                    alt: "subscription"
                },
                {
                    isArrow: true
                },
                {
                    title: "Get your bike",
                    description: "Pick up your bike from the nearest MYBYK Hub or have it delivered right at your doorstep.",
                    image: Locationhome,
                    alt: "location-icon"
                },
                {
                    isArrow: true
                },
                {
                    title: "Ride it like you own it!",
                    description: "Enjoy a worry-free ride! Replace malfunctioning bikes at any MYBYK Hub or right at your doorstep.",
                    image: MyBykRide,
                    alt: "riding-my-byk"
                }
            ],

            "swap_header_title": "Swap your bike<span>at any Metro Station</span>",
            "swap_description": "Long commute? Use MYBYK to connect your first and last mile with Kochi Metro. Drop & Pick MYBYK at <b>24+ Metro Stations.</b>",
            "swap_sub_description": "",
            "swap_main_video": "https://youtu.be/KTjUqI4EFQw?si=w-yVR7ND4h2ngfJx",
            "map_input_placeholder": "Search a MYBYK hub near you",

            // Hear out stories  
            "hear_out_header_title": "Hear out stories <span>of MYBYKERS</span>",

            // Here out stories video 
            "hear_out_video": [
                {
                    video: "https://youtu.be/VmLhn2YfkT8?si=6fKOvwff1LLXZKGR",
                },
                {
                    video: "https://youtu.be/RVl7GGld6ws?si=h68nNryTjQezmxe6",
                },
                {
                    video: "https://youtu.be/B67zP9F8fCM?si=Erp9ZmR_WBb-aRaQ",
                },
            ],

            // FAQ Section Question Answers 

            "faq_question_answers": [
                {
                    question: "How do I subscribe to MYBYK?",
                    answer:
                        "Subscribing is simple! Visit our website or app, select a plan, make the payment, and either pick up your bike from a nearby MYBYK hub or choose home delivery (available in select areas).",
                },
                {
                    question: "Where can I pick up and drop off the bike?",
                    answer:
                        "You can pick up a bike from any MYBYK hub in Kochi and drop it off at any other hub. With 55+ MYBYK hubs across the city, we ensure you're never far from a hub.",
                },
                {
                    question: "What kind of bicycles does MYBYK offer?",
                    answer:
                        "MYBYK offers high-quality pedal cycles built for daily commuting and city exploration. They are lightweight, durable, and perfect for rides of any length.",
                },

                {
                    question: "Are MYBYK hubs located conveniently?",
                    answer:
                        "Absolutely! MYBYK hubs are strategically located across Kochi, ensuring you have easy access to our bikes near key landmarks and transport points.",
                },
                {
                    question: "What if the bicycle malfunctions??",
                    answer:
                        "No problem! If the bicycle malfunctions, simply visit your nearest MYBYK hub and swap it for a replacement with your current subscription, at no additional cost.",
                },
                {
                    question: "Can I cancel my subscription anytime?",
                    answer:
                        "Yes, you can! Just return the bike to your nearest MYBYK hub, and your subscription will be canceled—hassle-free.",
                },
            ]

        },
        "indore": {
            "city_name": "indore",
            "banner_heading_local": "नमस्ते इंदौर",
            "banner_sub_heading": "Welcome to hassle free cycling",
            "banner_price_description": "Your all-inclusive bike subscription with free repairs and maintenance.",
            "banner_slider": [
                BannerImage,
                BannerImageSecond,
                BannerImageThird,
            ],
            "bike_showcase": [
                {
                    title: "Unisex Bike",
                    description:
                        "Strong & lightweight frame",
                    image: Case1,
                },
                {
                    title: "Stay Secure",
                    description: "Smart lock with IoT",
                    image: Case2,
                },
                {
                    title: "Easy Adjustable Seat",
                    description: "Simply pull, adjust & push ",
                    image: Case3,
                },
                {
                    title: "Frame Mounted Basket",
                    description:
                        "Carry upto 7 kgs payload",
                    image: Case4,
                },
                {
                    title: "Bottle Cage",
                    description: "Stay hydrated, ride strong",
                    image: Case5,
                },
            ],
            "how_to_use": [
                {
                    title: "Subscribe",
                    description: "Choose from our easily affordable plans - Daily, Weekly, Monthly or Pay As You Go.",
                    image: Subscript,
                    alt: "subscription"
                },
                {
                    isArrow: true
                },
                {
                    title: "Get your bike",
                    description: "Pick up your bike from the nearest MYBYK Hub or have it delivered right at your doorstep.",
                    image: Locationhome,
                    alt: "location-icon"
                },
                {
                    isArrow: true
                },
                {
                    title: "Ride it like you own it!",
                    description: "Enjoy a worry-free ride! Replace malfunctioning bikes at any MYBYK Hub or right at your doorstep.",
                    image: MyBykRide,
                    alt: "riding-my-byk"
                }
            ],

            "swap_header_title": "Swap your bike<span>at any BRTS Station</span>",
            "swap_description": "Long commute? Use MYBYK to connect your first and last mile with Indore BRTS. Drop & Pick MYBYK at <b>22+ BRTS Stations.</b>",
            "swap_sub_description": "",
            "swap_main_video": "https://youtu.be/7BlEKWCzFSg?si=I47YlB2owVDNY7z6",
            "map_input_placeholder": "Search a MYBYK hub near you",

            // Hear out stories  
            "hear_out_header_title": "Hear out stories <span>of MYBYKERS</span>",

            // Here out stories video 
            "hear_out_video": [
                {
                    video: "https://youtu.be/8rjprkY7QkQ",
                },
                {
                    video: "https://youtu.be/NZnqjR1_EQY?si=H2fs4qDEm9t99YSh",
                },
                {
                    video: "https://youtube.com/shorts/fC9F6hdZBF0",
                },
            ],

            // FAQ Section Question Answers 

            "faq_question_answers": [
                {
                    question: "How do I subscribe to MYBYK?",
                    answer:
                        "Subscribing is simple! Visit our website or app, select a plan, make the payment, and either pick up your bike from a nearby MYBYK hub or choose home delivery (available in select areas).",
                },
                {
                    question: "Where can I pick up and drop off the bike?",
                    answer:
                        "You can pick up a bike from any MYBYK hub in Indore and drop it off at any other hub. With 100+ MYBYK hubs across the city, we ensure you're never far from a hub.",
                },
                {
                    question: "What kind of bicycles does MYBYK offer?",
                    answer:
                        "MYBYK offers high-quality pedal cycles built for daily commuting and city exploration. They are lightweight, durable, and perfect for rides of any length.",
                },

                {
                    question: "Are MYBYK hubs located conveniently?",
                    answer:
                        "Absolutely! MYBYK hubs are strategically located across Indore, ensuring you have easy access to our bikes near key landmarks and transport points.",
                },
                {
                    question: "What if the bicycle malfunctions?",
                    answer:
                        "No problem! If the bicycle malfunctions, simply visit your nearest MYBYK hub and swap it for a replacement with your current subscription, at no additional cost.",
                },
                {
                    question: "Can I cancel my subscription anytime?",
                    answer:
                        "Yes, you can! Just return the bike to your nearest MYBYK hub, and your subscription will be canceled—hassle-free.",
                },
            ]

        },
        "mysuru": {
            "city_name": "mysuru",
            "banner_heading_local": "ನಮಸ್ಕಾರ ಮೈಸೂರು",
            "banner_sub_heading": "Enjoy the freedom of cycling",
            "banner_price_description": "Get a cycle subscription in Mysuru with zero stress.",
            "banner_slider": [
                BannerImageMySuru,

            ],
            "bike_showcase": [
                {
                    title: "Unisex Bike",
                    description:
                        "Strong & lightweight frame",
                    image: MysuruE1,
                },
                {
                    title: "PowerPedal",
                    description: "Pedal + Electric boost",
                    image: PowerPedal,
                },
                {
                    title: "Charge at home",
                    description: "25+ km range in a single charge!*",
                    image: ChargeAtHomeMysuru,
                },
                {
                    title: "Stay Secure",
                    description:
                        "Smart lock with IoT",
                    image: StaySecure,
                },
                {
                    title: "Easy Adjustable Seat",
                    description: "Simply pull, adjust & push ",
                    image: AdjustableSeat,
                },
            ],
            "how_to_use": [
                {
                    title: "Subscribe",
                    description: "Choose from our easily affordable plans - Daily, Weekly, Monthly or Pay As You Go.",
                    image: Subscript,
                    alt: "subscription"
                },
                {
                    isArrow: true
                },
                {
                    title: "Get your bike",
                    description: "Pick up your bike from the nearest TrinTrin Hub or have it delivered right at your doorstep.",
                    image: Locationhome,
                    alt: "location-icon"
                },
                {
                    isArrow: true
                },
                {
                    title: "Ride it like you own it!",
                    description: "Enjoy a worry-free ride! Replace malfunctioning bikes at any TrinTrin Hub or right at your doorstep.",
                    image: MyBykRide,
                    alt: "riding-my-byk"
                }
            ],
            "swap_header_title": "Swap your bike at<span>any TrinTrin Station</span>",
            "swap_description": "With TrinTrin powered by MYBYK, you can use the swap feature, drop your TrinTrin bicycles at any TrinTrin hub and pick another one from any other TrinTrin hub across the city.",
            "swap_sub_description": "Enjoy the flexibility to drop & pick TrinTrin cycles at <b>47 hubs</b> across Mysuru.",
            "swap_main_video": "https://www.instagram.com/reel/C3kWkhdLHcV/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
            "swap_main_thumbnail": InstagramThumbnail,
            "map_input_placeholder": "Search a TrinTrin hub near you",

            // Hear out stories  
            "hear_out_header_title": "Hear out stories <span>of TrinTrin Users</span>",

            // Here out stories video 
            "hear_out_video": [
                {
                    video: "https://youtube.com/shorts/ZZmv0qh8qYQ",
                },
                {
                    video: "https://youtube.com/embed/sJGYftVnExw",
                },
                {
                    video: " https://youtube.com/embed/fjvltek8bP4",
                },
            ],

            // FAQ Section Question Answers 

            "faq_question_answers": [
                {
                    question: "How do I subscribe to TrinTrin?",
                    answer:
                        "Subscribing is super simple! Visit our website or app, select a plan, make the payment, and either pick up your bike from a nearby hub or choose home delivery (available in select areas).",
                },
                {
                    question: "Where can I pick up and drop off the bike?",
                    answer:
                        "You can pick up a bike from any TrinTrin hub in Mysuru and drop it off at any other hub. With 45+ hubs across the city, it’s designed for your convenience.",
                },
                {
                    question: "What kind of bicycles does TrinTrin offer?",
                    answer:
                        "TrinTrin offers high-quality electric bicycles built for daily commuting and city exploration. They are lightweight, durable, and with the power pedal feature, they are perfect for rides of any length—no sweat and no tiredness.",
                },

                {
                    question: "Are TrinTrin hubs located conveniently?",
                    answer:
                        "Absolutely! TrinTrin electric hubs are conveniently located near major landmarks and public points across Mysuru city, making your travel smooth and efficient.",
                },
                {
                    question: "What if the bicycle malfunctions?",
                    answer:
                        "No worries! If your bicycle malfunctions, simply visit the nearest TrinTrin hub and swap it for a replacement. You can do this with your existing subscription at no extra cost.",
                },
                {
                    question: "Can I cancel my subscription anytime?",
                    answer:
                        "Yes, you can! Just return the bike to your nearest TrinTrin hub, and your subscription will be canceled—no hassle at all.",
                },
            ]
        },

    }

]

export default cityContent